const ACTIVE = 'a';
const DONE = 'i';
const DELETED = 'd';
const FUTURE = 'f';

module.exports = {
	ACTIVE,
	DONE,
	DELETED,
	FUTURE
};
